export default __webpack_public_path__ + "assets/images/logo-web-application-10x10.png";